var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-info",attrs:{"id":"footer-info"}},[_c('div',{attrs:{"id":"company-info"}},[_c('address',[_vm._v("\n\t\t\t\tAv. Borges de Medeiros, 633, Sala 405 - 408 | OFFICES LEBLON | CEP: 22430-041 | Leblon - Rio de Janeiro - Brasil | Tel:"),_c('a',{attrs:{"href":"tel:55 21 2142-9300"}},[_vm._v("55 21 2142-9300")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c18810c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Footer.vue
// module id = 824
// module chunks = 0